import $ from 'jquery';
import showOnScroll from '@zerofool/show-on-scroll';

$(function() {
	showOnScroll('.twin-cols__col');
});